export default __webpack_public_path__ + "static/media/blanco_logo_hyundai.449ff7ad.svg";